/* ==========================================================================
   OliveDrab — snap carousel rail
   Native scroll snapping with arrow buttons, a progress bar and keyboard
   support. No transform maths, so it stays smooth on low end phones and
   degrades to a plain scroller if the script never runs.
   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function reduced() {
    return window.OD && window.OD.prefersReduced ? window.OD.prefersReduced() : false;
  }

  function setup(rail) {
    if (rail.dataset.odRailBound) return;
    rail.dataset.odRailBound = '1';

    var track = $('[data-od-rail-track]', rail);
    if (!track) return;

    var prev = $('[data-od-rail-prev]', rail.closest('section') || rail) ||
               $('[data-od-rail-prev]', rail);
    var next = $('[data-od-rail-next]', rail.closest('section') || rail) ||
               $('[data-od-rail-next]', rail);
    var bar = $('[data-od-rail-bar]', rail);

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function scrollBy(dir) {
      var amount = step() * (window.innerWidth >= 990 ? 2 : 1);
      track.scrollBy({
        left: dir * amount,
        behavior: reduced() ? 'auto' : 'smooth'
      });
    }

    function update() {
      var max = maxScroll();
      var x = track.scrollLeft;
      // 2px tolerance for sub pixel scroll positions
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;

      if (bar) {
        var visible = track.clientWidth / Math.max(track.scrollWidth, 1);
        var pct = Math.max(visible, 0.08) * 100;
        var progress = max > 0 ? x / max : 0;
        bar.style.setProperty('--od-progress', pct.toFixed(2) + '%');
        // travel is the remaining track once the thumb width is removed
        bar.style.setProperty('--od-progress-x', (progress * (100 - pct)).toFixed(2) + '%');
      }
    }

    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });

    track.addEventListener('scroll', function () {
      if (rail._raf) return;
      rail._raf = requestAnimationFrame(function () {
        rail._raf = null;
        update();
      });
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollBy(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); scrollBy(-1); }
    });

    window.addEventListener('resize', update, { passive: true });

    // drag to scroll with a mouse, which desktop shoppers expect
    var down = false, startX = 0, startLeft = 0, moved = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = 0;
      startX = e.clientX;
      startLeft = track.scrollLeft;
      track.style.scrollSnapType = 'none';
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.abs(dx);
      if (moved > 3) {
        track.scrollLeft = startLeft - dx;
        rail.classList.add('is-dragging');
      }
    });

    function endDrag(e) {
      if (!down) return;
      down = false;
      track.style.scrollSnapType = '';
      rail.classList.remove('is-dragging');
      // swallow the click that follows a real drag
      if (moved > 4 && e && e.target && e.target.closest('a')) {
        var kill = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
        track.addEventListener('click', kill, { capture: true, once: true });
      }
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);

    update();
  }

  function init(ctx) {
    $$('[data-od-rail]', ctx || document).forEach(function (rail) {
      try { setup(rail); } catch (e) {
        if (window.console && console.warn) console.warn('[OD rail]', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.OD = window.OD || {};
  window.OD.initRails = init;
})();
